<template>
  <!-- 背景 -->
  <div
    class="w-100 h-100 p-3 McsBgImg overflow-auto"
    :style="`background: url('${FrameData.bgSource}') top center`"
  >
    <!-- 活動頁 begin -->
    <!-- 遮罩 -->
    <div
      class="container mx-auto p-3 p-md-4 p-lg-5 rounded-lg"
      :style="`background: rgba(${FrameData.transparentMask},${(type || endpage) ? 0.85 : FrameData.transparentValue/100});`"
    >
      <div class="text-center d-flex h-100 align-items-center flex-column">
        <!-- 特殊標籤, 形狀：rounded-pill/rounded/rounded-0 -->
        <b-badge
          v-if="FrameData.tagName"
          class="my-2 py-2 px-3 rounded-pill"
          :style="`background: rgba(${FrameData.tagColor}, 1.0); color: rgba(${FrameData.tagColor === '255,255,255' ? '45,167,193' : '255,255,255' },1.0);`"
        >
          {{ FrameData.tagName }}
        </b-badge>
        <!-- 標題文字/標題圖片 begin -->
        <div class="w-100">
          <h3
            v-if="FrameData.titleType === 'text'"
            :style="`color: rgba(${type ? (FrameData.transparentMask === '255,255,255' ? '0,0,0' : '255,255,255') : FrameData.titleColor}, 1.0);`"
          >
            {{ FrameData.titleDesc }}
          </h3>
          <img
            v-if="FrameData.titleType === 'img'"
            class="mb-3 w-100"
            :src="FrameData.titleImg"
            alt=""
            style="max-width: 600px;"
          >
          <h6
            v-if="endpage && !type"
            :style="`color: rgba(${FrameData.transparentMask === '255,255,255' ? '0,0,0' : '255,255,255'}`"
          >
            {{ isAward ? $t('activity.congratuation-on-getting')+award : award }}
          </h6>
        </div>
        <!-- 標題文字/標題圖片 end -->
        <slot name="content" />
      </div>
    </div>
    <!-- 活動頁 end -->
  </div>
</template>

<script>
export default {
  props: {
    type: Boolean,
    endpage: {
      type: Boolean,
      default: false,
    },
    isAward: Boolean,
    award: String,
  },
  data() {
    return {
      // 活動資料
      activity: { scratchOffInfo: {}, slotInfo: {}, rouletteInfo: {} },
      FrameData: {
        bgSource: '',
        tagColor: '',
        tagName: '',
        titleColor: '',
        titleDesc: '',
        transparentMask: '',
        transparentValue: 0,
        titleImg: '',
        titleType: '',
      },
    };
  },
  created() {
    const vm = this;

    // 取得活動資料
    vm.$store.dispatch('getActivity').then(
      (activity) => {
        vm.activity = activity;
        switch (activity.categoryID) {
          case 'Scratchoff':
            vm.FrameData.bgSource = activity.scratchOffInfo.bgSource;
            vm.FrameData.tagColor = activity.scratchOffInfo.tagColor;
            vm.FrameData.tagName = activity.scratchOffInfo.tagName;
            vm.FrameData.titleColor = activity.scratchOffInfo.titleColor;
            vm.FrameData.titleDesc = activity.scratchOffInfo.titleDesc;
            vm.FrameData.transparentMask = activity.scratchOffInfo.transparentMask;
            vm.FrameData.transparentValue = activity.scratchOffInfo.transparentValue;
            vm.FrameData.titleImg = activity.scratchOffInfo.titleImg;
            vm.FrameData.titleType = activity.scratchOffInfo.titleType;
            break;
          case 'Slot':
            vm.FrameData.bgSource = activity.slotInfo.bgSource;
            vm.FrameData.tagColor = activity.slotInfo.tagColor;
            vm.FrameData.tagName = activity.slotInfo.tagName;
            vm.FrameData.titleColor = activity.slotInfo.titleColor;
            vm.FrameData.titleDesc = activity.slotInfo.titleDesc;
            vm.FrameData.transparentMask = activity.slotInfo.transparentMask;
            vm.FrameData.transparentValue = activity.slotInfo.transparentValue;
            vm.FrameData.titleImg = activity.slotInfo.titleImg;
            vm.FrameData.titleType = activity.slotInfo.titleType;
            break;
          case 'Roulette':
            vm.FrameData.bgSource = activity.rouletteInfo.bgSource;
            vm.FrameData.tagColor = activity.rouletteInfo.tagColor;
            vm.FrameData.tagName = activity.rouletteInfo.tagName;
            vm.FrameData.titleColor = activity.rouletteInfo.titleColor;
            vm.FrameData.titleDesc = activity.rouletteInfo.titleDesc;
            vm.FrameData.transparentMask = activity.rouletteInfo.transparentMask;
            vm.FrameData.transparentValue = activity.rouletteInfo.transparentValue;
            vm.FrameData.titleImg = activity.rouletteInfo.titleImg;
            vm.FrameData.titleType = activity.rouletteInfo.titleType;
            break;
          default:
            break;
        }
      },
    );
  },
};
</script>

<style>
.McsBgImg{
  background-size: cover !important;
  }

  @media screen and (min-width: 768px) {
  .McsBgImg{  background-size: contain !important; }
  }
</style>
